document.addEventListener("DOMContentLoaded", function () {
  const url = window.location.href;
  const variantPattern = /[?&]variant=\d+/;  
  if (variantPattern.test(url)) {
    return; 
  }
   let buttonAdded = false;
   let sizeSelect = document.querySelectorAll('input[type="radio"]');

 sizeSelect.forEach(radio => {
    if (radio.getAttribute("data-option-name")?.toLowerCase().includes("size")) {
      radio.removeAttribute("checked");  
      // Check if the button has already been added
      //  if (!buttonAdded) {
      //   const buttonsContainer = document.querySelector(".buy-buttons");
      //   const addToCartBtn = document.querySelector("buy-buttons .button");
 
      //   addToCartBtn.style.display = "none";
      //   if (buttonsContainer) {
      //      const html = `
      //      <div class="choose-variant-wrapper">
      //       <div class="choose-variant w-full">Select size<div class="select-size-dot"></div></div>
      //       <div class="select_variant-text"  style="display: none;" >* Please select size</div>
      //     </div>
      //       `;
      //   buttonsContainer.innerHTML += html;         
      //     buttonAdded = true;
      //   }       
      // }
      if (!buttonAdded) {
    const buttonsContainers = document.querySelectorAll(".buy-buttons");

    buttonsContainers.forEach((container) => {
        const addToCartBtns = container.querySelectorAll(".button");

        addToCartBtns.forEach((btn) => {
            btn.style.display = "none";
        });

        const html = `
            <div class="choose-variant-wrapper">
            <a href="#select-size-link">
                <div class="choose-variant w-full">               
                    Select size
                    <div class="select-size-dot"></div>
                </div>             
                </a>
            </div>
        `;

        container.innerHTML += html;
    });

    buttonAdded = true; // Mark that the button has been added
}

    }    
  });
});


// setTimeout(() => {
//   const sizeSelectBtn = document.querySelector(".choose-variant"); 
//   const sizeSelectText = document.querySelector(".select_variant-text"); 
//   if (sizeSelectBtn && sizeSelectText) {
//     sizeSelectBtn.addEventListener("click", (e) => {
//       sizeSelectText.style.display = "block";
//     });
//   }
  
// }, 3);